<div class='bio-page-outer'>
  <div class='bio-page-inner'>

    <div class="bio-content">
      <div class="photo">
        <img class='menu-logo' src="/assets/img/e-art-bio.jpg" alt="E-art bio">
      </div>
      <div class="title">
        <div>{{ 'bio.header' | translate }}</div>
      </div>
      <div class="text">
        <div>{{ 'bio.line1' | translate }}</div>
        <div>{{ 'bio.line2' | translate }}</div>
        <div>{{ 'bio.line3' | translate }}</div>
      </div>
    </div>

  </div>  
</div>